// buy-box interactivity (sync retrigger)
(function () {
  function initBuybox(root) {
    if (root.dataset.sbxInit === '1') return;
    root.dataset.sbxInit = '1';

    var state = { mode: root.dataset.sbxMode || 'sub' };
    var idInput = root.querySelector('[data-sbx-id-input]');
    var planInput = root.querySelector('[data-sbx-plan-input]');

    function selectedTile() {
      return root.querySelector('[data-sbx-tile].sbx__tile--selected');
    }

    function formatMoney(amount) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      if (currency === 'USD') {
        return '$' + (amount / 100).toFixed(2);
      }
      try {
        var formatted = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'symbol'
        }).format(amount / 100);
        return formatted.replace(/\s+/g, '');
      } catch (e) {
      }
      return currency + ' ' + (amount / 100).toFixed(2);
    }

    function updateStickyBar(tile, price, mode) {
      var stickyRoot = document.querySelector('[data-dopa-sticky-atc]');
      if (!stickyRoot || !tile) return;

      var packs = parseInt(tile.getAttribute('data-packs'), 10) || 1;
      var compare = parseFloat(tile.getAttribute('data-compare')) || 0;
      var priceNum = parseFloat(price);
      if (isNaN(priceNum)) return;

      var titleEl = stickyRoot.querySelector('[data-dopa-sticky-title]');
      var compareEl = stickyRoot.querySelector('[data-dopa-sticky-compare]');
      var priceEl = stickyRoot.querySelector('[data-dopa-sticky-price]');
      var permoEl = stickyRoot.querySelector('[data-dopa-sticky-permo]');
      var saveEl = stickyRoot.querySelector('[data-dopa-sticky-save]');

      if (titleEl) {
        var supplyLabel = packs === 1 ? '1 Month Supply' : packs + ' Months Supply';
        titleEl.textContent = packs + '-Pack — ' + supplyLabel;
      }

      if (compareEl) {
        if (compare > priceNum) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (priceEl) priceEl.textContent = formatMoney(priceNum);

      if (permoEl) {
        if (mode === 'sub' && packs > 1) {
          permoEl.textContent = ' · ' + formatMoney(priceNum / packs) + '/mo';
          permoEl.hidden = false;
        } else {
          permoEl.hidden = true;
        }
      }

      if (saveEl) {
        if (compare > priceNum) {
          var pct = Math.round((compare - priceNum) / compare * 100);
          saveEl.textContent = 'SAVE ' + pct + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function updateTopBar(tile, price) {
      var topBars = document.querySelectorAll('[data-dopa-topbar]');
      if (!topBars.length || !tile) return;

      var compare = parseFloat(tile.getAttribute('data-compare')) || 0;
      var priceNum = parseFloat(price);
      if (isNaN(priceNum)) return;

      var giftIdsRaw = tile.getAttribute('data-gift-variant-ids') || '';
      var giftCount = giftIdsRaw.split(',').filter(function (s) { return s.trim() !== ''; }).length;

      var text = '';
      if (compare > priceNum) {
        var pct = Math.round((compare - priceNum) / compare * 100);
        text = 'Save ' + pct + '%';
      }
      if (giftCount === 1) {
        text += (text ? ' + ' : '') + 'Free Gift';
      } else if (giftCount > 1) {
        text += (text ? ' + ' : '') + 'Free Gifts';
      }
      if (!text) return;

      topBars.forEach(function (bar) {
        var textEl = bar.querySelector('[data-dopa-topbar-text]');
        if (textEl) textEl.textContent = text;
      });
    }

    function render() {
      root.dataset.sbxMode = state.mode;
      root.querySelectorAll('[data-sbx-mode]').forEach(function (btn) {
        if (btn.tagName !== 'BUTTON') return;
        var active = btn.getAttribute('data-sbx-mode') === state.mode;
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      root.querySelectorAll('[data-sbx-tile]').forEach(function (tile) {
        var price = state.mode === 'sub'
          ? tile.getAttribute('data-price-sub')
          : tile.getAttribute('data-price-onetime');
        var priceNum = parseFloat(price);

        var priceEl = tile.querySelector('[data-sbx-price]');
        if (priceEl && !isNaN(priceNum)) {
          priceEl.textContent = formatMoney(priceNum);
        }

        var chipEl = tile.querySelector('[data-sbx-chip]');
        if (chipEl && !isNaN(priceNum)) {
          var packs = parseInt(tile.getAttribute('data-packs'), 10) || 1;
          chipEl.textContent = formatMoney(priceNum / packs) + ' per pack';
        }
      });

      var tile = selectedTile();
      if (tile) {
        idInput.value = tile.getAttribute('data-variant-id');
        if (state.mode === 'sub' && tile.getAttribute('data-plan-id')) {
          planInput.value = tile.getAttribute('data-plan-id');
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }

        var stickyPrice = state.mode === 'sub'
          ? tile.getAttribute('data-price-sub')
          : tile.getAttribute('data-price-onetime');
        updateStickyBar(tile, stickyPrice, state.mode);
        updateTopBar(tile, stickyPrice);
      }
    }

    root.addEventListener('click', function (e) {
      var modeBtn = e.target.closest('[data-sbx-mode]');
      if (modeBtn && modeBtn.tagName === 'BUTTON') {
        state.mode = modeBtn.getAttribute('data-sbx-mode');
        render();
        return;
      }
      var tile = e.target.closest('[data-sbx-tile]');
      if (tile) {
        root.querySelectorAll('[data-sbx-tile]').forEach(function (t) {
          t.classList.remove('sbx__tile--selected');
          t.setAttribute('aria-checked', 'false');
          t.setAttribute('tabindex', '-1');
        });
        tile.classList.add('sbx__tile--selected');
        tile.setAttribute('aria-checked', 'true');
        tile.setAttribute('tabindex', '0');
        render();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var target = e.target.closest('[data-sbx-tile], [data-sbx-mode]');
      if (!target) return;
      e.preventDefault();
      target.click();
    });

    render();

    var scope = root.closest('product-rerender') || document;
    var mo = new MutationObserver(function () {
      if (!document.body.contains(root)) return;
      if (root.dataset.sbxMode !== state.mode) render();
    });
    mo.observe(scope, { childList: true, subtree: true });

    var formEl = document.getElementById(idInput.getAttribute('form'));
    if (formEl) {
      formEl.addEventListener('product:rerender', function () {
        setTimeout(function () {
          var tile = selectedTile();
          if (!tile) return;
          var price = state.mode === 'sub'
            ? tile.getAttribute('data-price-sub')
            : tile.getAttribute('data-price-onetime');
          updateStickyBar(tile, price, state.mode);
          updateTopBar(tile, price);
        }, 0);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sbx]').forEach(initBuybox);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();
  document.addEventListener('shopify:section:load', initAll);

  function findBuyboxForForm(form) {
    var scope = form.closest('product-rerender');
    if (scope) {
      var inScope = scope.querySelector('[data-sbx]');
      if (inScope) return inScope;
    }
    var candidates = document.querySelectorAll('[data-sbx]');
    for (var i = 0; i < candidates.length; i++) {
      var idInput = candidates[i].querySelector('[data-sbx-id-input]');
      if (idInput && idInput.getAttribute('form') === form.id) return candidates[i];
    }
    return candidates[0] || null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var root = findBuyboxForForm(form);
    if (!root) return;

    var ourIdInput = root.querySelector('[data-sbx-id-input]');
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name === 'id' && el !== ourIdInput) {
        el.disabled = true;
      }
    });

    var planInputs = form.querySelectorAll('input[name="selling_plan"]');
    planInputs.forEach(function (input) {
      if (root.dataset.sbxMode !== 'sub') input.disabled = true;
    });
  }, true);
})();
